import { Outlet, Link, useLocation } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export function AutomationsLayout() {
  const location = useLocation();
  const tab = location.pathname === "/automations/runs" ? "runs" : "templates";

  return (
    <div className="p-4">
      <Tabs value={tab} className="w-full">
        <TabsList className="mb-4">
          <TabsTrigger asChild value="templates">
            <Link to="/automations">Templates</Link>
          </TabsTrigger>
          <TabsTrigger asChild value="runs">
            <Link to="/automations/runs">Runs</Link>
          </TabsTrigger>
        </TabsList>
        <Outlet />
      </Tabs>
    </div>
  );
}
